import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  Col,
  Form,
  Image,
  Modal,
  Row,
  Table
} from 'react-bootstrap';
import classNames from 'classnames';
import Flex from 'components/common/Flex';
import SubtleBadge from 'components/common/SubtleBadge';
import SimpleBarReact from 'simplebar-react';
import moment from 'moment';
import Avatar from 'components/common/Avatar';
import IconButton from 'components/common/IconButton';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import { getAllFacilityOrgList } from 'nursd-dashboard/api/organizationTable';
import { toast } from 'react-toastify';
import { sendNotification } from 'nursd-dashboard/api/webNotification';
import { socket } from 'nursd-dashboard/api/socket';
import { postNurseNotification } from 'nursd-dashboard/api/nurseNotification';
import {
  getNurseAvaJobDate,
  getNurseDetails
} from 'nursd-dashboard/api/nurseTable';
import {
  postNurseTimeOff,
  updateNurseTimeOff
} from 'nursd-dashboard/api/timeoffNurse';
import DatePicker from 'react-datepicker';
import { duration } from 'nursd-dashboard/data/defaultData';
import {
  formatPhoneNumber,
  removeFormatting
} from 'nursd-dashboard/utils/function';

export function timeDifferentCard(sTime, eTime) {
  const startTime = moment(moment(new Date(sTime)).format('hh:mma'), 'hh:mm A');

  const start = moment(new Date(sTime));
  const end = moment(new Date(eTime));

  const endTime = moment(moment(new Date(eTime)).format('hh:mma'), 'hh:mm A');
  const endTimeEnd = moment(
    moment(new Date(eTime)).format('hh:mma'),
    'hh:mm A'
  ).add(1, 'day');

  const duration = moment.duration(endTime.diff(startTime));
  const durationEnd = moment.duration(endTimeEnd.diff(startTime));

  const hours = Math.floor(duration.asHours());
  const hoursEnd = Math.floor(durationEnd.asHours());
  const minutes = Math.floor(duration.asMinutes()) - hours * 60;

  const onlyHours = `${
    end.hour() <= 12 && start.hour() <= 12
      ? hours
      : end.hour() <= 12
      ? hoursEnd
      : hours
  }${hours <= 1 ? 'h' : 'h'} ${minutes <= 0 ? '' : `${minutes}m`}`;

  return onlyHours;
}

const TransactionItem = ({
  summary: {
    approvedManagerData,
    nurseData,
    nurseCancelNotes,
    timeOffReason,
    startDate,
    startTime,
    endDate,
    endTime,
    comments,
    status,
    id
  },
  isLast,
  facility,
  refresh,
  setRefresh
}) => {
  const { authToken } = useAuth();

  const actionTimeOff = async approveStatus => {
    if (approveStatus === 'Approved') {
      const resp = await getNurseAvaJobDate(
        authToken,
        Number(nurseData?.id),
        nurseData?.uniqueId,
        moment(startDate).format('YYYY-MM-DD'),
        moment(endDate).format('YYYY-MM-DD'),
        moment(startTime).format('hh:mm a'),
        moment(endTime).format('hh:mm a')
      );

      if (resp?.availableTime) {
        try {
          const resTime = await updateNurseTimeOff(authToken, Number(id), {
            status: approveStatus,
            comments: '',
            approved_manager: facility?.id?.toString()
          });

          socket?.emit('tableTimeOffInsert', {
            table: 'NurseTimeOff',
            nurseTableID: Number(nurseData?.id)
          });
          sendNotification(authToken, {
            expoPushToken: nurseData?.mobileId,
            title: `Time Off Request(${moment(resTime?.startDate).format(
              'MMM DD'
            )})`,
            body: `Time off Request Approved.`,
            data: { screen: 'TimeOffScreen' }
          });
          await postNurseNotification(
            authToken,
            Number(nurseData?.id),
            '',
            `Time Off Request(${moment(resTime?.startDate).format('MMM DD')})`,
            `Time off Request Approved.`,
            'TimeOffScreen',
            {
              id: ''
            },
            false,
            false,
            'green',
            ''
          ).catch(e => console.log('error', e, nurseData?.id));
          socket?.emit('tableNotificationInsert', {
            table: 'NurseNotificationTable',
            id: nurseData?.id
          });

          toast.success('Time Off request approved successfully.', {
            theme: 'colored'
          });
          setRefresh(!refresh);
        } catch (error) {
          console.log('data save error:', error);
        }
      } else {
        toast.danger(`Date Conflict.Choose a different date.`, {
          theme: 'colored'
        });
      }
    } else {
      try {
        const resTime = await updateNurseTimeOff(authToken, Number(id), {
          status: approveStatus,
          comments: '',
          approved_manager: facility?.id?.toString(),
          nurseCancelNotes: nurseCancelNotes
        });
        socket?.emit('tableTimeOffInsert', {
          table: 'NurseTimeOff',
          nurseTableID: nurseData?.id
        });
        sendNotification(authToken, {
          expoPushToken: nurseData?.mobileId,
          title: `Time Off Request(${moment(resTime?.startDate).format(
            'MMM DD'
          )})`,
          body: `Time off Request Not Approved.`,
          data: { screen: 'TimeOffScreen' }
        });
        await postNurseNotification(
          authToken,
          Number(nurseData?.id),
          '',
          `Time Off Request(${moment(resTime?.startDate).format('MMM DD')})`,
          `Time off Request Not Approved`,
          'TimeOffScreen',
          {
            id: ''
          },
          false,
          false,
          'red',
          ''
        );
        socket?.emit('tableNotificationInsert', {
          table: 'NurseNotificationTable',
          id: nurseData?.id
        });
        toast.success('Time Off request not-approved successfully.', {
          theme: 'colored'
        });
        setRefresh(!refresh);
      } catch (error) {
        console.log('data save error:', error);
      }
    }
  };

  return (
    <tr className={classNames({ 'border-0': isLast })}>
      <td
        className={classNames('align-middle ps-0 text-nowrap', {
          'border-0': isLast
        })}
      >
        <Flex alignItems="center" className="position-relative">
          {/* <Image src={img} alt={title} className="me-2" width={30} /> */}
          <div className="flex-1">
            <h6 className="mb-0">Reason : {timeOffReason}</h6>
            {comments && <p className="mb-0">Comments : {comments}</p>}
            {nurseCancelNotes && (
              <p className="mb-0">Cancellation Notes : {nurseCancelNotes}</p>
            )}
          </div>
        </Flex>
      </td>
      <td className={classNames('align-middle px-4', { 'border-0': isLast })}>
        {startDate === endDate ? (
          <h6 className="mb-0">{moment(startDate).format('MMM-DD')}</h6>
        ) : (
          <h6 className="mb-0">
            {moment(startDate).format('MMM-DD')} -{' '}
            {moment(endDate).format('MMM-DD')}
          </h6>
        )}
      </td>
      <td className={classNames('align-middle px-4', { 'border-0': isLast })}>
        {startTime === '' && endTime === '' ? (
          <h6 className="mb-0">Full Day</h6>
        ) : (
          <h6 className="mb-0">
            {moment(new Date(startTime)).format('h:mm a')}-
            {moment(new Date(endTime)).format('h:mm a')} (
            {timeDifferentCard(startTime, endTime)})
          </h6>
        )}
      </td>
      <td
        className={classNames('align-middle px-4', { 'border-0': isLast })}
        style={{ width: '1%' }}
      >
        <SubtleBadge
          bg={classNames({
            success: status === 'Approved',
            secondary: status === 'Pending',
            warning: status === 'Cancelled',
            danger: status === 'Not-Approved'
          })}
          className="fs-10 w-100"
        >
          {status}
        </SubtleBadge>
      </td>
      <td
        className={classNames('align-middle px-4 text-end text-nowrap', {
          'border-0': isLast
        })}
        style={{ width: '1%' }}
      >
        <Flex alignItems="center" className="position-relative">
          {status !== 'Pending' &&
            (approvedManagerData?.profileImage ? (
              <Image
                roundedCircle
                src={approvedManagerData?.profileImage}
                alt={
                  approvedManagerData?.firstName +
                  ' ' +
                  approvedManagerData?.lastName
                }
                className="me-2"
                width={40}
                height={40}
              />
            ) : (
              <Avatar
                size="2xl"
                name={
                  approvedManagerData?.firstName +
                  ' ' +
                  approvedManagerData?.lastName
                }
                className="me-2"
              />
            ))}
          <div className="flex-1">
            {status === 'Pending' ? (
              // <h6 className="mb-0">Waiting</h6>
              <Flex>
                <Button
                  variant="success"
                  size="sm"
                  onClick={() => actionTimeOff('Approved')}
                >
                  Approve
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  className="mx-3"
                  onClick={() => actionTimeOff('Not-Approved')}
                >
                  Reject
                </Button>
              </Flex>
            ) : (
              <>
                <h6 className="mb-0">{status} By</h6>
                <p className="fs-11 mb-0">
                  {approvedManagerData?.firstName +
                    ' ' +
                    approvedManagerData?.lastName}
                </p>
              </>
            )}
          </div>
        </Flex>
      </td>
      {/* <td
        className={classNames('align-middle ps-4 pe-1', { 'border-0': isLast })}
        style={{ width: '130px', minWidth: '130px' }}
      >
        <Form.Select size="sm" className="px-2">
          <option value="action">Action</option>
          <option value="Approved">Approved</option>
          <option value="Not-Approved">Not-Approved</option>
          <option value="Cancelled">Cancelled</option>
        </Form.Select>
      </td> */}
    </tr>
  );
};

const TimeOffViewList = ({
  data: transactions,
  nurseId,
  uniqueId,
  refresh,
  setRefresh,
  facility
}) => {
  const animatedComponents = makeAnimated();
  const { authToken, location, organization } = useAuth();
  const [nurse, setNurse] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [loadingScreen, setLoadingScreen] = useState(true);
  const [viewModel, setViewModel] = useState(false);
  const [managers, setManagers] = useState([]);
  const [valueManager, setValueManager] = useState(null);
  const [valueDuration, setValueDuration] = useState(null);
  const [formData, setFormData] = useState({
    timeOffReason: '',
    startDate: new Date(),
    endDate: new Date(),
    fullDay: true,
    alternateContact: '',
    phoneNum: '',
    comments: '',
    facilityTableId: '',
    facilityTableName: ''
  });

  const handleClose = () => {
    setLoading(false);
    setViewModel(false);
    setValueManager(null);
    setValueDuration(null);
    setFormData({
      timeOffReason: '',
      startDate: new Date(),
      endDate: new Date(),
      fullDay: true,
      alternateContact: '',
      phoneNum: '',
      comments: '',
      facilityTableId: '',
      facilityTableName: ''
    });
  };

  const handleChange = ({ target }) => {
    let name = target.name;
    let value = name === 'fullDay' ? target.checked : target.value;
    setFormData({ ...formData, [name]: value });
  };

  function GetDateMergedTime(date, time) {
    const date1 = moment(date).format('YYYY-MM-DD');
    const time1 = moment(time).format('hh:mm a');
    const mergedTime = moment(`${date1} ${time1}`, `YYYY-MM-DD hh:mm a`);
    return mergedTime;
  }

  const checkUser = async (authToken, id) => {
    try {
      await getNurseDetails(authToken, id).then(res => {
        if (res === undefined) {
          setNurse(null);
          setLoadingScreen(false);
        } else {
          setNurse(res);
          setLoadingScreen(false);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (nurseId !== null) {
      checkUser(authToken, nurseId);
    }
  }, [nurseId]);

  const getManager = async () => {
    try {
      const cusList = await getAllFacilityOrgList(
        authToken,
        location,
        organization
      );

      const list = cusList.sort((a, b) =>
        a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase())
      );
      let array = [];
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        let obj = {
          id: item.id,
          value: item.id,
          uniqueId: item.uniqueId,
          name: item.firstName + ' ' + item.lastName,
          label: item.firstName + ' ' + item.lastName,
          profileImage: item.profileImage,
          emailId: item.emailId,
          facilityLoginControl: item?.facilityLoginControl
        };
        array.push(obj);
      }

      if (list.length === array.length) {
        setManagers(array);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (authToken) {
      getManager();
    }
  }, [authToken]);

  const postData = async () => {
    try {
      setLoading(true);
      const res = await getNurseAvaJobDate(
        authToken,
        Number(nurseId),
        uniqueId,
        moment(formData?.startDate).format('YYYY-MM-DD'),
        moment(formData?.endDate).format('YYYY-MM-DD'),
        moment(formData?.startDate).format('hh:mm a'),
        moment(formData?.endDate).format('hh:mm a')
      );
      // console.log('getNurseAvaJobDate', res);
      if (res?.availableTime) {
        let sDate = moment(formData.startDate).format('YYYY-MM-DD');
        let eDate = moment(formData.endDate).format('YYYY-MM-DD');
        try {
          await postNurseTimeOff(
            authToken,
            Number(nurseId),
            formData.timeOffReason,
            sDate,
            formData?.fullDay
              ? ''
              : GetDateMergedTime(
                  formData.startDate.toString(),
                  formData?.startDate.toString()
                ).toString(),
            eDate,
            formData?.fullDay
              ? ''
              : GetDateMergedTime(
                  formData.endDate.toString(),
                  formData?.endDate.toString()
                ).toString(),
            removeFormatting(formData.alternateContact),
            removeFormatting(nurse?.phoneNumber),
            organization,
            location,
            formData.comments,
            'Approved',
            '',
            formData?.facilityTableId?.toString()
          ).then(async res => {
            await postNurseNotification(
              authToken,
              Number(nurseId),
              '',
              `Time Off Request(${moment(res?.startDate).format('MMM DD')})`,
              `TimeOff added successfully.`,
              'MyDocumentsScreen',
              {},
              false,
              false,
              'green',
              ''
            );
            socket?.emit('tableTimeOffInsert', {
              table: 'NurseTimeOff',
              nurseTableID: Number(nurseId)
            });
            socket?.emit('tableNotificationInsert', {
              table: 'NurseNotificationTable',
              id: Number(nurseId)
            });
            if (nurse?.mobileId) {
              sendNotification(authToken, {
                expoPushToken: nurse?.mobileId,
                title: `Time Off Request(${moment(res?.startDate).format(
                  'MMM DD'
                )})`,
                body: `TimeOff added successfully.`,
                data: { screen: 'TimeOffScreen' }
              });
            }
            toast.success(`TimeOff added successfully.`, {
              theme: 'colored'
            });
            setRefresh(!refresh);
            setLoading(false);
            setViewModel(false);
            setValueManager(null);
            setValueDuration(null);
            setFormData({
              timeOffReason: '',
              startDate: new Date(),
              endDate: new Date(),
              fullDay: true,
              alternateContact: '',
              phoneNum: '',
              comments: '',
              facilityTableId: '',
              facilityTableName: ''
            });
          });
        } catch (error) {
          console.log('data save error:', error);
          setLoading(false);
        }
      } else {
        // console.log(res);
        toast.error(`Date Conflict.Choose a different date.`, {
          theme: 'colored'
        });
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const postNurseTime = async () => {
    postData();
  };

  const handleSubmit = e => {
    e.preventDefault();
    postNurseTime();
  };

  return (
    <>
      {loadingScreen ? (
        <p className="mt-2">Loading...</p>
      ) : (
        <Card className="overflow-hidden">
          <Card.Header className="pe-0">
            <Flex className="g-2">
              <Col>
                <h5 className="mb-0">Time Off List ({transactions?.length})</h5>
              </Col>
              <Col xs="auto" className="d-flex order-md-0">
                <IconButton
                  variant="primary"
                  iconClassName="me-2"
                  icon="plus"
                  size="sm"
                  className="mx-3"
                  onClick={() => {
                    setViewModel(true);
                  }}
                >
                  TimeOff
                </IconButton>
              </Col>
            </Flex>
          </Card.Header>
          <Card.Body className="py-0">
            {transactions?.length === 0 ? (
              <div className="my-3">
                <p>No Data Available</p>
              </div>
            ) : (
              <SimpleBarReact>
                <Table className="table-dashboard mb-0 fs-10">
                  <tbody>
                    {transactions.map((item, index) => (
                      <TransactionItem
                        key={item.id}
                        index={index}
                        isLast={index === transactions.length - 1}
                        summary={item}
                        facility={facility}
                        refresh={refresh}
                        setRefresh={setRefresh}
                      />
                    ))}
                  </tbody>
                </Table>
              </SimpleBarReact>
            )}
          </Card.Body>
          <Modal
            size="lg"
            show={viewModel}
            keyboard={false}
            backdrop="static"
            aria-labelledby="example-modal-sizes-title-lg"
            onHide={handleClose}
            contentClassName="border"
          >
            <Form onSubmit={handleSubmit}>
              <Modal.Header
                closeButton
                className="bg-body-tertiary px-x1 border-bottom-0"
              >
                <Modal.Title as="h5">Add TimeOff</Modal.Title>
              </Modal.Header>
              <Modal.Body className="p-x1">
                <Row className="mb-2">
                  <Form.Group
                    as={Col}
                    md="4"
                    className="mb-2"
                    controlId="Manager"
                  >
                    <Form.Label className="fs-9">Manager</Form.Label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      placeholder="Select..."
                      isClearable
                      isSearchable
                      name="color"
                      value={valueManager}
                      onChange={value => {
                        setValueManager(value);
                        setFormData({
                          ...formData,
                          facilityTableId: value?.id,
                          facilityTableName: value?.label
                        });
                      }}
                      options={managers}
                      components={animatedComponents}
                      required
                    />
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    md="4"
                    className="mb-2"
                    controlId="timeOffReason"
                  >
                    <Form.Label className="fs-9">Tim Off Reason</Form.Label>
                    <Form.Control
                      type="text"
                      name="timeOffReason"
                      placeholder="Title"
                      required
                      value={formData?.timeOffReason}
                      onChange={handleChange}
                    />
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    md="2"
                    className="mb-2 pt-4"
                    controlId="fullDay"
                  >
                    <Form.Check
                      type="checkbox"
                      id="fullDay"
                      label="Full Day"
                      name="fullDay"
                      value={formData.fullDay}
                      checked={formData.fullDay}
                      onChange={handleChange}
                    />
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    md="2"
                    className="mb-2 pt-4"
                    controlId="fullDay"
                  >
                    <Form.Check
                      type="checkbox"
                      id="fullDay"
                      label="Partial Day"
                      name="fullDay"
                      value={!formData.fullDay}
                      checked={!formData.fullDay}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Row>
                {formData?.fullDay ? (
                  <Row className="mb-2">
                    <Form.Group
                      as={Col}
                      md="6"
                      className="mb-2"
                      controlId="startDate"
                    >
                      <Form.Label className="fs-9">Start</Form.Label>
                      <DatePicker
                        selected={formData?.startDate}
                        onChange={v => {
                          let dateStart = new Date(v);
                          let dateEnd = new Date(v);

                          // Set start time to 12:01 AM
                          dateStart.setHours(0); // 0 hours in 24-hour format is 12:00 AM
                          dateStart.setMinutes(1);

                          // Set end time to 11:59 PM
                          dateEnd.setHours(23); // 23 hours in 24-hour format is 11:00 PM
                          dateEnd.setMinutes(59);

                          setFormData({
                            ...formData,
                            startDate: dateStart,
                            endDate: dateEnd
                          });
                        }}
                        className="form-control"
                        placeholderText="MM-DD-YYYY"
                        dateFormat="MM-dd-yyyy"
                      />
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md="6"
                      className="mb-2"
                      controlId="End"
                    >
                      <Form.Label className="fs-9">End</Form.Label>
                      <Form.Control
                        type="text"
                        name="End"
                        disabled
                        value={moment(formData?.endDate).format('MM-DD-YYYY')}
                      />
                    </Form.Group>
                  </Row>
                ) : (
                  <Row className="mb-2">
                    <Form.Group
                      as={Col}
                      md="4"
                      className="mb-2"
                      controlId="startDate"
                    >
                      <Form.Label className="fs-9">Start</Form.Label>
                      <DatePicker
                        selected={formData?.startDate}
                        onChange={v => {
                          setFormData({
                            ...formData,
                            startDate: v,
                            endDate: v
                          });
                        }}
                        className="form-control"
                        placeholderText="MM-DD-YYYY H:M"
                        dateFormat="MM-dd-yyyy h:mm aa"
                        showTimeSelect
                      />
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md="4"
                      className="mb-2"
                      controlId="Duration"
                    >
                      <Form.Label className="fs-9">Duration</Form.Label>
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        placeholder="Select..."
                        isClearable
                        isSearchable
                        required
                        name="color"
                        value={valueDuration}
                        onChange={value => {
                          setValueDuration(value);

                          let date = new Date();
                          let dateEnd = new Date();
                          let newEnd = new Date(formData.startDate);
                          let selectedHourTime =
                            newEnd.getHours() === 0
                              ? 12
                              : newEnd.getHours() > 12
                              ? newEnd.getHours() - 12
                              : newEnd.getHours();
                          let selectedMinuteTime = newEnd
                            .getMinutes()
                            .toString()
                            .padStart(2, '0');
                          let selectedAPTime =
                            newEnd.getHours() >= 12 ? 'PM' : 'AM';

                          date.setHours(
                            selectedAPTime === 'AM' && selectedHourTime === 12
                              ? 0
                              : selectedAPTime === 'PM' &&
                                selectedHourTime === 12
                              ? 12
                              : selectedHourTime !== 12 &&
                                selectedAPTime === 'PM'
                              ? parseInt(selectedHourTime) + 12
                              : parseInt(selectedHourTime)
                          );
                          date.setMinutes(selectedMinuteTime);
                          date.setFullYear(newEnd.getFullYear());
                          date.setMonth(newEnd.getMonth());
                          date.setDate(newEnd.getDate());

                          // Add 8 hours to dateEnd based on date
                          dateEnd.setFullYear(date.getFullYear());
                          dateEnd.setMonth(date.getMonth());
                          dateEnd.setDate(date.getDate());
                          dateEnd.setHours(date.getHours() + value?.value);
                          dateEnd.setMinutes(date.getMinutes());

                          // Determine if it's AM or PM
                          let meridiem = dateEnd.getHours() >= 12 ? 'PM' : 'AM';

                          if (selectedAPTime === 'PM' && meridiem === 'AM') {
                            // let endDate = moment(formData.startDate);
                            // endDate.add(1, 'day');
                            setFormData({
                              ...formData,
                              startDate: date,
                              endDate: dateEnd
                            });
                          } else {
                            setFormData({
                              ...formData,
                              startDate: date,
                              endDate: dateEnd
                            });
                          }
                        }}
                        options={duration}
                        components={animatedComponents}
                      />
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md="4"
                      className="mb-2"
                      controlId="End"
                    >
                      <Form.Label className="fs-9">End</Form.Label>
                      <Form.Control
                        type="text"
                        name="End"
                        disabled
                        value={moment(formData?.endDate).format(
                          'MM-DD-YYYY hh:mm A'
                        )}
                      />
                    </Form.Group>
                  </Row>
                )}
                <Row className="mb-2">
                  <Form.Group as={Col} md="6" controlId="phoneNumber">
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Phone Number"
                      name="phoneNumber"
                      value={formatPhoneNumber(nurse?.phoneNumber)}
                      onChange={handleChange}
                      // pattern="[0-9]*"
                      disabled
                    />
                  </Form.Group>
                  <Form.Group as={Col} md="6" controlId="alternateContact">
                    <Form.Label>Alternate Contact (optional)</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Alternate Contact"
                      name="alternateContact"
                      value={formatPhoneNumber(formData?.alternateContact)}
                      onChange={handleChange}
                      // pattern="[0-9]*"
                    />
                  </Form.Group>
                </Row>
                <Row className="mb-2">
                  <Form.Group as={Col} md="12" controlId="comments">
                    <Form.Label className="fs-9">Comments</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="comments"
                      value={formData?.comments}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Row>
              </Modal.Body>
              <Modal.Footer className="bg-body-tertiary px-x1 border-top-0">
                <Button variant="primary" type="submit" className="px-4 mx-0">
                  {loading ? 'Loading...' : 'Publish'}
                </Button>
                <Button
                  variant="secondary"
                  type="submit"
                  className="px-4 mx-2"
                  onClick={() => handleClose()}
                >
                  Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </Modal>
        </Card>
      )}
    </>
  );
};

TransactionItem.propTypes = {
  summary: PropTypes.shape({
    approvedManagerData: PropTypes.object.isRequired,
    nurseData: PropTypes.object.isRequired,
    nurseCancelNotes: PropTypes.string.isRequired,
    timeOffReason: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired,
    startTime: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired,
    endTime: PropTypes.string.isRequired,
    alternateContactNumber: PropTypes.string.isRequired,
    phoneNumber: PropTypes.string.isRequired,
    comments: PropTypes.string.isRequired,
    status: PropTypes.bool.isRequired,
    organization: PropTypes.string.isRequired,
    location_id: PropTypes.string.isRequired,
    nurseTableID: PropTypes.number.isRequired,
    id: PropTypes.number.isRequired
  }),
  isLast: PropTypes.bool.isRequired,
  facility: PropTypes.any,
  refresh: PropTypes.any,
  setRefresh: PropTypes.any
};

TimeOffViewList.propTypes = {
  data: PropTypes.arrayOf(TransactionItem.propTypes.summary),
  nurseId: PropTypes.any,
  uniqueId: PropTypes.any,
  refresh: PropTypes.any,
  setRefresh: PropTypes.any,
  facility: PropTypes.any
};

export default TimeOffViewList;
